import { Controller } from '@hotwired/stimulus';
import CurrentPage from '@frontend/app/features/CurrentPage';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class extends Controller {
  connect() {
    this.paywallDivider = document.querySelector('.js-paywall-divider');
    if (!CurrentPage.isArticlePaywalled()) {
      this.notifyAccessWallLoaded();
    } else {
      this.load();
    }
  }

  load() {
    this.paywallDivider.style.height = '1px';

    if (CurrentPage.isAccessWallIframeLocked()) {
      window.__accessWallIframeLoadCompleted =
        this.accessWallIframeLoadCompleted.bind(this);

      this.iframe = document.querySelector(
        `#${CurrentPage.accessWallIframeId()}`
      );
      this.iframe.setAttribute(
        'onload',
        'window.__accessWallIframeLoadCompleted()'
      );
      this.iframe.setAttribute('data-src', CurrentPage.accessWallIframeSrc());
      this.iframe.classList.add('lazyload');

      const wallSibling = document.querySelector(
        '.js-access-wall, .js-follow-wall-template'
      ).nextElementSibling;

      if (wallSibling) {
        this.blurSiblingNodes(wallSibling);
      }
    } else {
      if (CurrentUser.isGuest()) {
        this.displayShareUrlPromotion();
      } else {
        this.paywallDivider.style = 'display: none';
      }
      this.notifyAccessWallLoaded();
    }
  }

  blurSiblingNodes(node) {
    do {
      node.classList.add('json-ld-paywall-marker');
      node.classList.add('blurred');
      node.classList.add('hidden@print');
      node = node.nextElementSibling;
    } while (node);
  }

  accessWallIframeLoadCompleted() {
    this.iframe.contentWindow.addEventListener(
      'resize',
      this.handleAccessWallIframeResize.bind(this)
    );
    this.handleAccessWallIframeResize();
    setTimeout(this.handleAccessWallIframeResize.bind(this), 2000);
    this.notifyAccessWallLoaded();
  }

  notifyAccessWallLoaded() {
    document.body.classList.add('js-access-wall-is-loaded');
  }

  handleAccessWallIframeResize() {
    this.iframe.style.height =
      this.iframe.contentDocument.body.scrollHeight + 'px';
  }

  displayShareUrlPromotion() {
    const template = document.querySelector(
      '.js-share-url-promotion-box-template'
    );
    this.paywallDivider.insertAdjacentElement('afterend', template);
  }
}
